export interface DeviceValue {
  id: number;
  value: number;
}

export interface DeviceError {
  logCode: number;
  errorCode: string;
  date: number;
  description: string;
}

export enum ParameterType {
  PARAMETER = 'parameter',
  VARIABLE = 'variable',
}

export interface IParameter {
  name: string;
  minValue: number;
  maxValue: number;
  defaultValue: number;
  hexAddress: string;
  description?: string;
  logGraph: boolean;
  numBytes: number;
  parameterGroupId: number;
  nameToShow?: string;
  parameterIdRcu: number;
  parameterType: ParameterType;
}

export interface DeviceTemperature {
  actual: number;
  actualType: number;
  id: number;
  name?: string;
  onMainScreen: boolean;
  set: number;
  setType: number;
  weight: number;
}

export interface Device {
  apiVersion: string;
  unit: {
    id: string;
    type: number;
    version: string;
    command: string;
    rssi: number;
    ip: string;
    timezone: string;
    temperature: number;
  };
  controller: {
    type: number;
    version: string;
    command: string;
    status: number;
    heatingSlope: number;
    stoveLastAvailability: number;
    mobileLastAvailability: number;
    currentTime: number;
    error: number;
    alert: number;
    timerEnable: boolean;
    fuelType: number;
    timeToService: number;
    delayedStartAt: number;
    delayedStopAt: number;
    power: {
      setType: number;
      actualType: number;
      kw: number;
      actualPower: number;
      setPower: number;
    };
    antifreeze: {
      temperature: number;
      enable: boolean;
    };
    statistic: {
      igniterStarts: number;
      uptime: number;
      heatingTime: number;
      serviceTime: number;
      overheatings: number;
      misfires: number;
      fuelQuantityUsed: number;
    };
    diagnostic: {
      parameters: DeviceValue[];
      variables: DeviceValue[];
      timers: DeviceValue[];
    };
    temperatures: DeviceTemperature[];
  };
}

export interface ParameterCategory {
  label: string;
  parameters: number[];
}
